import { createTheme, alpha } from "@mui/material/styles";

/**
 * Booking-focused theme: calm, trustworthy, easy to scan.
 */
export const bookingTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0d9488",
      dark: "#0f766e",
      light: "#2dd4bf",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0369a1",
      dark: "#075985",
      light: "#38bdf8",
    },
    background: {
      default: "#f4f7f9",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#475569",
    },
    divider: "rgba(15, 23, 42, 0.08)",
  },
  typography: {
    fontFamily:
      '"Inter", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: "none",
      letterSpacing: "0.02em",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          paddingLeft: 20,
          paddingRight: 20,
        },
        sizeLarge: {
          paddingTop: 12,
          paddingBottom: 12,
          fontSize: "1rem",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: `0 1px 3px ${alpha("#0f172a", 0.06)}`,
          border: `1px solid ${alpha("#0f172a", 0.06)}`,
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontWeight: 500,
        },
      },
    },
  },
});
